<template>
  <main :class="{'dark': darkTheme}">
    <div class="visually-impaired">
        <p style="color: black">для користувачів з вадами зору:</p>
        <img id="increaseFont"
          @click="changeFontSize"
          :src='increaseFont'
          class="visually-impaired-icon">
        <img id="changeBackground"
          :src=changeBackground
          @click="changeTheme"
          class="visually-impaired-icon">
        <img id="undo" 
          @click="cancelInclusiveMode"
          :src=close
          class="visually-impaired-icon">
    </div>
    <div class="title">
      <img :src=usaid alt="">
      <img :src=engageLabel alt="">
      <img :src=pact alt="">
    </div>
    <h1>18 РОКІВ КОРУПЦІЇ У СПРИЙНЯТТІ ТА ДОСВІДІ УКРАЇНЦІВ</h1>
    <p>З 2007 року в Україні кожні два роки, за винятком 2013, 2017 та 2020 проводилось масштабне національне опитування щодо стану корупції в Україні. 
      Нижче ви можете переглянути візуалізацію отриманих результатів. 
      Вона допоможе вам проналізувати відмінності у досвіді і сприйнятті корупції в окремих регіонах та в різні роки. 
      Ми почнемо із історії <a href="#firstBlock" class="innerPageLink">сприйняття проблеми корупції</a>, 
      потім подивимося на <a href="#secondBlock" class="innerPageLink">мотивацію</a> та <a href="#thirdBlock" class="innerPageLink">демографію</a> тих, хто готовий боротися із корупцією, 
      проаналізуємо <a href="#forthBlock" class="innerPageLink">сприйняття корумпованості влади</a> і врешті побачимо, в яких сферах <a href="#fifthBlock" class="innerPageLink">громадяни особисто стикалися</a> із корупцією.
    </p>
    <h3 class="section-title" id="firstBlock">1. КОРУПЦІЯ НА ТЛІ ІНШИХ ПРОБЛЕМ</h3>
    <div class="switcher" @mouseenter="switcherHover_1 = true" @mouseleave="switcherHover_1 = false">
      <Toggle v-model="sectionSwitch_1" onLabel="on"/>
      <p>Зміна виборки</p>
      <div class="switcher-tooltip" :class="{'hidden': !switcherHover_1}">активуйте слайдер праворуч в зелену позицію, щоб змінити вибірку з загальної (усі опитані) на тих, хто стикався з корупцією</div>
    </div>
    <div class="section-columns map">
      <div>
        <div class="section-title-block">
          <h4 class="block-subtitle section_1">ВВАЖАЮТЬ КОРУПЦІЮ СЕРЙОЗНОЮ ПРОБЛЕМОЮ (2024)</h4>
          <p v-if="sectionSwitch_1">Серед тих хто стикався з корупцією</p>
        </div>
        <MapBase :mapChartNum=1 :data="sectionData_1_1" :color='sectionColor_1' @region-selected="regionSelected"></MapBase>
      </div>
      <div>
        <h4 class="block-subtitle section_1" style="margin-bottom: 50px; max-width: 500px;">Динаміка сприйняття корупції (назвали проблему серйозною)</h4>
        <LineChartBase :data="sectionData_1_2" :color='sectionColor_1' :ticks="[75, 80, 85, 90, 95, 100]"></LineChartBase>
        <p class="people-number">Вибірка 2024 року n={{ sectionData_1_3.peopleNumber }} осіб</p>
      </div>
    </div>
    <p>Натисніть на область на карті аби побачити, наскільки важливими для неї є топ-5 національних проблем за 2024 рік.</p>
    <div class="section-columns">
      <div class="section-column-radar">
        <h3 class="block-subtitle">Україна</h3>
        <RadarChartBase :radarChartNum=1 :data="sectionData_1_3" :colorSet="sectionColors_1"></RadarChartBase>
      </div>
      <div class="section-column-radar">
        <h3 class="block-subtitle">{{ sectionData_1_4.name }}</h3>
        <RadarChartBase :radarChartNum=2 :data="sectionData_1_4" :colorSet="sectionColors_1"></RadarChartBase>
      </div>
      <div class="section-column-start">
        <div class="question-title" v-for="(question, index) in sectionData_1_4.questions" :key=index>
          <div class="color-dot" :style="{'background-color': sectionColors_1[index]}"></div>
          {{ question.name }}
        </div>
      </div>
    </div>
    <p>З початку проведення нашого дослідження у 2007 році, проблема корупції сприймається як
      серйозна не менш як 5/6 громадян. У 2024 році корупція посідає друге місце в топ-5
      національних проблем, після повномасштабної війни. Найлегше порівняно з іншими регіонами
      корупція сприймається на Київщині та у Києві, найбільш гостро – у Кіровоградській та
      Черкаській областях.
    </p>
    <!-- <p>Дані секції відображають суму відповідей "Скоріше серйозна" та "Дуже серйозна" на питання
      "Як Ви вважаєте, наскільки серйозними є нижче перераховані проблеми для України?".
    </p> -->
    <h3 class="section-title" id="secondBlock">2. ЩО СПОНУКАЄ / ЗАВАЖАЄ ДОЛУЧАТИСЯ ДО АНТИКОРУПЦІЙНОЇ ДІЯЛЬНОСТІ (2024)</h3>
    <h3 class="block-subtitle">ТОП 3 ПРИЧИНИ</h3>
    <div class="section-columns-around">
      <div class="section-column">
        <h3 class="block-subtitle">Спонукає</h3>
        <RadarChartBase :radarChartNum=3 :data="section_2_1" :colorSet="sectionColors_2_1"></RadarChartBase>
        <div class="questions-block">
          <div class="question-title" v-for="(question, index) in section_2_1.questions" :key=index>
            <div class="color-dot" :style="{'background-color': sectionColors_2_1[index]}"></div>
            {{ question.name }}
          </div>
        </div>
      </div>
      <div class="section-column">
        <h3 class="block-subtitle">Заважає</h3>
        <RadarChartBase :radarChartNum=4 :data="section_2_2" :colorSet="sectionColors_2_2"></RadarChartBase>
        <div class="question-title" v-for="(question, index) in section_2_2.questions" :key=index>
          <div class="color-dot" :style="{'background-color': sectionColors_2_2[index]}"></div>
          {{ question.name }}
        </div>
      </div>
    </div>
    <!-- <p>
      Дані секції відображають суму відповідей "Скоріше спонукає" та "Дуже спонукає" на
      питання "Що може спонукати Вас брати участь в антикорупційній діяльності?". А також
      суму відповідей "Скоріше заважає" та "Дуже заважає" на питання "Що заважає Вам брати
      участь в антикорупційній діяльності?". Лише топ три причини зазначені.
    </p> -->
    <h3 class="section-title" id="thirdBlock">3. ГОТОВНІСТЬ ДО АНТИКОРУПЦІЙНОЇ ДІЯЛЬНОСТІ КРІЗЬ ПРИЗМУ ДЕМОГРАФІЇ (2024)</h3>
    <div class="section-selector">
      <div class="selector-block left">
        <h3 class="block-subtitle-selector">{{ sectionCategoryLeft_3 }}</h3>
        <img :src=arrowLeft alt="" @click="sectionPrev_3">
        
      </div>
      <div class="selector-block center">
        <h3 class="block-subtitle">{{ sectionCategory_3 }}</h3>
        <RadarChartBase :radarChartNum=5 :data="sectionDataChart_3" :colorSet="sectionColors_3"></RadarChartBase>
      </div>
      <div class="selector-block right">
        <img :src=arrowRight alt="" @click="sectionNext_3">
        <h3 class="block-subtitle-selector">{{ sectionCategoryRight_3 }}</h3>
      </div>
    </div>
    <div class="section-question-block">
      <div 
      class="section-question" 
        v-for="(question, index) in sectionDataChart_3.questions" 
        :key="question.name" 
        :style="{'color': sectionColors_3[index]}"
      >
        <div class="color-dot" :style="{'background-color': sectionColors_3[index]}"></div>
        <p>{{ question.name }}</p>
      </div>
    </div>
    <h3 class="block-subtitle">Регіональний розподіл</h3>
    <div class="section-question-block">
      <div 
      class="section-question" 
        v-for="(question, index) in sectionDataChart_3.questions" 
        :key="question.name" 
        :style="{'color': sectionColors_3[index]}"
      >
        <MapBase :mapChartNum=(index) :data="sectionMapCategoryFilter_3(question.name)" :color=mapColor(index)></MapBase>
      </div>
    </div>
    <p>
      Чоловіки, освічені, люди в достатку та молоді готові протистояти корупції більше за
      інших. Особливе значення має регіональний розподіл. В Київській та Кіровоградській
      областях найменший рівень готовності до антикорупційної діяльності. Тимчасом, 
      в Тернопільській, Рівненській та Дніпропетровській областях найвищий рівень готовності 
      до антикорупційної діяльності.
    </p>
    <!-- <p>
      Окрім перелічених зрізів, також спостерігаються тенденції і в інших демографічних
      розрізах. Так, зі збільшенням кількості членів родини, люди більш готові бути залученими до
      антикорупційної діяльності, однак зі спадною віддачою (5+ членів родини). Основний рід
      занять також впливає. Наприклад, працюючі пенсіонери більш готові бути залученими до
      антикорупційної діяльності, ніж непрацюючі (72% vs 52%). А найбільш готові бути
      залученими до антикорупційної діяльності саме студенти - 83% .
    </p>
    <p>
      Готовність бути залученими вимірювалася за допомогою калькуляції відповідей на
      запропоновані 9 активностей. Детальніше дивиться в Методології. Демографічний розріз
      за доходом базувався на питанні "Подивіться, будь ласка, на картку і скажіть, яке із
      тверджень найточніше відповідає фінансовому становищу Вашої родини?", в якому
      показник "Вистачає коштів принаймні на їжу і одяг" складається з суми відповідей "У нас
      достатньо грошей на їжу й одяг, і ми можемо дещо відкладати, але цього не досить, щоб
      купувати дорогі речі (такі, як телевізор або холодильник)", "Ми можемо дозволити собі
      купувати деякі дорогі речі (такі, як телевізор або холодильник)" та "Ми можемо дозволити
      собі все, що забажаємо".
    </p> -->
    <h3 class="section-title" id="forthBlock">4. (АНТИ)КОРУПЦІЯ В ОРГАНАХ ВЛАДИ *</h3>
    <div class="switcher" @mouseenter="switcherHover_4 = true" @mouseleave="switcherHover_4 = false">
      <Toggle v-model="sectionSwitch_4" onLabel="on"/>
      <p>Зміна виборки</p>
      <div class="switcher-tooltip" :class="{'hidden': !switcherHover_4}">
        активуйте слайдер праворуч в зелену позицію, щоб перемкнути вибірку з загальної (усі опитані) на відсоток від тих, хто готовий долучитись до антикорупційної діяльності.
      </div>
    </div>
    <div class="section-selector">
      <div class="selector-block left">
        <h3 class="block-subtitle-selector">{{ sectionCategoryLeft_4 }}</h3>
        <img :src=arrowLeft alt="" @click="sectionPrev_4">
        
      </div>
      <div class="selector-block center">
        <h3 class="block-subtitle">{{ sectionCategory_4 }}</h3>
        <RadarChartBase :radarChartNum=6 :data="sectionDataChart_4" :colorSet="sectionColors_3"></RadarChartBase>
      </div>
      <div class="selector-block right">
        <img :src=arrowRight alt="" @click="sectionNext_4">
        <h3 class="block-subtitle-selector">{{ sectionCategoryRight_4 }}</h3>
      </div>
    </div>
    <div class="section-question-block">
      <div 
      class="section-question" 
        v-for="(question, index) in sectionDataChart_4.questions" 
        :key="question.name" 
        :style="{'color': sectionColors_3[index]}"
      >
        <div class="color-dot" :style="{'background-color': sectionColors_3[index]}"></div>
        <p>{{ question.name }}</p>
      </div>
    </div>
    <h3 class="block-subtitle">Регіональний розподіл</h3>
    <div class="section-question-block">
      <div 
      class="section-question" 
        v-for="(question, index) in sectionDataChart_4.questions" 
        :key="question.name" 
        :style="{'color': sectionColors_3[index]}"
      >
        <MapBase :mapChartNum=(index) :data="sectionMapCategoryFilter_4(question.name)" :color=mapColor(index)></MapBase>
      </div>
    </div>
    <h3 class="block-subtitle">ДИНАМІКА ПО РОКАХ</h3>
    <div class="section-question-block">
      <div 
        class="section-question" 
          v-for="(question, index) in sectionDataChart_4.questions" 
          :key="question.name" 
          :style="{'color': sectionColors_3[index]}"
        >
        <LineChartBase :data="sectionMapCategoryFilter_4(question.name)[27].years" :color=mapColor(index)></LineChartBase>
      </div>
    </div>
    <p class="people-number">Вибірка у 2024 році n={{ sectionDataChart_4.questions[0].peopleNumber }} осіб</p>
    <br>
    <p>
      Українці вважають, що корупція поширена в органах державної влади, таких як Верховна Рада, Кабінет Міністрів та Офіс Президента. 
      Частка респондентів, які вважають, що звичайні громадяни, громадянське суспільство та антикорупційні інституції є ключовими гравцями 
      в боротьбі з корупцією, зросла.
    </p>
    <!-- <p>
      Показник "Корупція у […] дуже поширена" базується на трьох наступних питаннях, де була
      використана опція "Дуже поширена": "На Вашу думку, наскільки поширена корупція в [НАЗВІТЬ
      СФЕРУ ЖИТТЯ]?" (Для Прокуратури, Національної поліції, Судової системи); "На Вашу думку,
      наскільки поширена корупція в таких органах влади?"; "На Вашу думку, наскільки поширена
      корупція в таких антикорупційних органах та організаціях?".
      Показник "[…] хоче подолати корупцію в України" складається з суми відповідей "Скоріше
      хочуть" та "Дуже хочуть" на питання "Як Ви вважаєте, чи хоче(-уть) [НАЗВІТЬ ОРГАН
      ВЛАДИ/ОРГАНІЗАЦІЮ] подолати корупцію в Україні".
      Показник "[…] відповідає за подолання корупції в Україні" базується на відповіді "Так" на
      питання "На Вашу думку, хто відповідальний за подолання корупції в Україні?".
    </p> -->
    <p class="subtitle">
      * Оскільки сфери та органи влади змінювалися між першим і останнім опитуванням, для
      забезпечення можливості порівняння деякі сфери та органи влади були ототожнені.
      Зокрема, так було зроблено щодо національної поліції та прокуратури, хоча в минулих
      опитуваннях в деяких питаннях міліція фігурувала разом із прокуратурою.
    </p>
    <h3 class="section-title" id="fifthBlock">5. КОРУПЦІЯ В ПОВСЯКДЕННОМУ ЖИТТІ</h3>
    <div class="switcher" @mouseenter="switcherHover_5 = true" @mouseleave="switcherHover_5 = false">
      <Toggle v-model="sectionSwitch_5" onLabel="on"/>
      <p>Зміна виборки</p>
      <div class="switcher-tooltip" :class="{'hidden': !switcherHover_5}">
        активуйте слайдер праворуч в зелену позицію, щоб перемкнути вибірку з загальної (усі опитані) на відсоток від тих, хто стикався із зазначеною сферою      
      </div>
    </div>
    <div class="section-selector">
      <div class="selector-block left">
        <h3 class="block-subtitle-selector">{{ sectionCategoryLeft_5 }}</h3>
        <img :src=arrowLeft alt="" @click="sectionPrev_5">
        
      </div>
      <div class="selector-block center">
        <h3 class="block-subtitle">{{ sectionCategory_5 }}</h3>
        <RadarChartBase :radarChartNum=7 :data="sectionDataChart_5" :colorSet="sectionColors_3"></RadarChartBase>
      </div>
      <div class="selector-block right">
        <img :src=arrowRight alt="" @click="sectionNext_5">
        <h3 class="block-subtitle-selector">{{ sectionCategoryRight_5 }}</h3>
      </div>
    </div>
    <div class="section-question-block">
      <div 
      class="section-question" 
        v-for="(question, index) in sectionDataChart_5.questions" 
        :key="question.name" 
        :style="{'color': sectionColors_3[index]}"
      >
        <div class="color-dot" :style="{'background-color': sectionColors_3[index]}"></div>
        <p>{{ question.name }}</p>
      </div>
    </div>
    <h3 class="block-subtitle">Регіональний розподіл</h3>
    <div class="section-question-block">
      <div 
      class="section-question" 
        v-for="(question, index) in sectionDataChart_5.questions" 
        :key="question.name" 
        :style="{'color': sectionColors_3[index]}"
      >
        <MapBase :mapChartNum=(index) :data="sectionMapCategoryFilter_5(question.name)" :color=mapColor(index)></MapBase>
      </div>
    </div>
    <div class="section-question-block">
      <div 
        class="section-question" 
          v-for="(question, index) in sectionDataChart_5.questions" 
          :key="question.name" 
          :style="{'color': sectionColors_3[index]}"
        >
        <LineChartBase :data="sectionMapCategoryFilter_5(question.name)[27].years" :color=mapColor(index)></LineChartBase>
      </div>
    </div>
    <p class="people-number">Вибірка у 2024 році n={{ sectionDataChart_5.questions[0].peopleNumber }} осіб</p>
    <br>
    <p>
      Громадяни частіше стикалися з корупцією в критичних сферах, зокрема у сферах середньої освіти, 
      охорони здоров’я та у Національній поліції.
    </p>
    <!-- <p>
      Показник "Сприймають сферу […] корумпованою" складається з суми відповідей "Дуже
      поширена" та "Частково поширена" на питання "На Вашу думку, наскільки поширена
      корупція в [НАЗВІТЬ СФЕРУ ЖИТТЯ]?".
      Показник "Стикалися зі сферою […] протягом року" базується на відповіді "Так" на питання
      "Протягом останніх 12-ти місяців чи доводилось Вам або членам Вашої родини стикатись з
      органами влади або державними закладами з будь-якого питання?".
      Показник "Мають особистий досвід корупції у сфері […]" враховується якщо хоча б на одне з
      наступних трьох питань відповідь була "Так": "Чи вимагали від Вас або членів Вашої родини
      хабаря (грошей, подарунка, протекції, послуги)?"; "Чи пропонували Ви або члени Вашої
      родини самі хабаря (гроші, подарунки, протекцію, послуги) для отримання послуг? " та "Чи
      використовували Ви, або хтось із членів Вашої родини, або державний чиновник особисті
      зв’язки, кумівство або протекціонізм («блат») для отримання послуг?".    
    </p> -->
    <footer>
      <button class="methodology-button" @click="methodologyVisible = !methodologyVisible">Методологія дослідження</button>
      <div v-if="methodologyVisible" style="font-size: 1em; margin-bottom: 50px;">
          <p>
            У візуалізації використані дані восьми досліджень громадської думки про
            стан корупції в Україні, що проводилися з 2007 до 2024 року.
            Дослідження
            проводились за випадковою багатоступінчастою вибіркою з квотним
            відбором на останньому етапі. На першому етапі формування вибірки в
            межах кожної області випадковим чином були відібрані населені пункти
            пропорційно до кількості населення в них. Другий етап передбачав
            випадковий відбір виборчих дільниць (у 2007 - 2011 роках – поштових
            відділень) на території відібраних населених пунктів. На території
            кожної з відібраних дільниць випадковим чином відбирались вулиці,
            будинки та квартири. Останнім етапом був відбір респондента в межах
            домогосподарства і безпосереднє проведення опитування. Отримані дані
            зіставлялись із даними про статево-вікову структуру населення за
            даними Державної служби статистики.
          </p>
          <p>
            У 2024 році дані зібрано в електронному вигляді (ОСА-САРІ). Цільовою сукупністю цієї підвибірки є люди віком від 18 років, 
            які проживають у попередньо відібраних областях України, які не були переміщеними з лютого 2022 року. 
            Вибірка охоплювала місто Київ та 19 областей: Київську, Вінницьку, Волинську, Дніпропетровську, Житомирську, 
            Закарпатську, Івано-Франківську, Кіровоградську, Львівську, Миколаївську, Одеську, Полтавську, Рівненську, 
            Тернопільську, Харківську, Хмельницьку, Черкаську, Чернівецьку, Чернігівську.
          </p>
          <p>
            Загальна вибірка кожного дослідження перевищує 10 тис. осіб.
            Теоретична похибка досліджень складає 1% для загальнонаціональної
            вибірки.
          </p>
          <p>
            Через те, що в полах питання про досвід корупції були сформульовані
            по-різному, за досвід корупції визначається згідно з питаннями про
            усі сфери.
          </p>
          <p>
            Оскільки сфери та органи влади змінювалися між першим і останнім
            опитуванням, для забезпечення можливості порівняння деякі сфери та
            органи влади були ототожнені. Зокрема, так було зроблено щодо
            національної поліції та прокуратури, хоча в минулих опитуваннях в
            деяких питаннях міліція фігурувала разом із прокуратурою.
          </p>
          <table>
            <thead>
              <th>Питання</th>
              <th>2024</th>
              <th>2023</th>
              <th>2021</th>
              <th>2018</th>
              <th>2015</th>
              <th>2011</th>
              <th>2009</th>
              <th>2007</th>
            </thead>
            <tbody>
              <tr>
                <td>На Вашу думку, хто відповідальний за подолання корупції в Україні?</td>
                <td>Національна поліція</td>
                <td>Національна поліція</td>
                <td>Національна поліція</td>
                <td>Національна поліція</td>
                <td>Міліція та спеціалізовані правоохоронні органи для боротьби з корупцією <i>(в переліку також були
                    присутні НАБУ, НАЗК, СБУ)</i></td>
                <td>Міліція та прокуратура</td>
                <td>Міліція та прокуратура</td>
                <td>Міліція та прокуратура</td>
              </tr>
              <tr>
                <td>На Вашу думку, наскільки поширена корупція в…</td>
                <td>…Національній поліції (включаючи патрульну поліцію)?</td>
                <td>…Національній поліції (включаючи патрульну поліцію)?</td>
                <td>…Національній поліції (включаючи патрульну поліцію)?</td>
                <td>…Національній поліції (включаючи патрульну поліцію)?</td>
                <td>…в міліції (без ДАІ)?</td>
                <td>…в міліції (без ДАІ)?</td>
                <td>…в міліції (без ДАІ)?</td>
                <td>…в міліції (без ДАІ)?</td>
              </tr>
              <tr>
                <td>На Вашу думку, хто відповідальний за подолання корупції в Україні?</td>
                <td>Прокуратура</td>
                <td>Прокуратура</td>
                <td>Прокуратура</td>
                <td>Прокуратура</td>
                <td>Прокуратура</td>
                <td>Міліція та прокуратура</td>
                <td>Міліція та прокуратура</td>
                <td>Міліція та прокуратура</td>
              </tr>
              <tr>
                <td>На Вашу думку, наскільки поширена корупція в…</td>
                <td>Прокуратурі</td>
                <td>Прокуратурі</td>
                <td>Прокуратурі</td>
                <td>Прокуратурі</td>
                <td>Прокуратурі</td>
                <td>Прокуратурі</td>
                <td>Прокуратурі</td>
                <td>Прокуратурі</td>
              </tr>
            </tbody>
          </table>
          <p>
            Перелік сфер дещо змінювався, а саме: в 2018 році додалася сфера
            системи державних закупівель, якої не було в попередніх опитуваннях,
            зате зникла сфера ДАІ, функції якої були ширшими за функції
            сервісних центрів МВС. Для підрахування досвіду корупції були обрані
            тільки ті питання, що відображали функції ДАІ, які перебрали
            сервісні центр МВС (отримання водійських прав, проведення технічного
            огляду, реєстрація автомобіля). Через те, що питання «Чи стикалися
            ви зі ДАІ?» стосувалося ширшого переліку функції ліквідованого
            органу, рахувати показники від тих, хто стикався зі сферою, було б
            некоректним.
          </p>
          <p>
            Вважалося, що респондент мав досвід корупції у більшості зі сфер,
            якщо він ствердно відповідав на 3 питання щодо сфери:
          </p>
          <ol>
            <li>
              Чи вимагали від Вас або членів Вашої родини хабаря (грошей,
              подарунка, протекції, послуги) під час звернень?
            </li>
            <li>
              Чи пропонували Ви або члени Вашої родини самі хабаря (гроші,
              подарунки, протекцію, послуги) для отримання послуг під час
              звернень?
            </li>
            <li>Чи використовували особисті зв’язки для отримання послуг?</li>
          </ol>
          <p>
            Утім, в опитування 2007 року були задані тільки перші 2 питання з 3,
            тому врахувати досвід використання особистих зв’язків у цьому
            опитуванні немає можливості.
          </p>
          <p>
            У сферах охорони здоров’я, шкільної освіти та ДАІ (в опитуваннях до
            2015 року включно) був заданий інший перелік питань, із
            специфікацією можливого корупційного досвіду, та іншим переліком
            відповідей. Вважалося, що респондент має корупційний досвід, якщо
            його примушували дати хабар або придбати дещо, або ж якщо він
            добровільно давав хабар, аби отримати потрібний результат, навіть
            якщо його не змушували (наприклад, при проведенні технічного
            огляду). У разі якщо за відсутності примусу матеріальні втрати з
            боку отримувача послуг можна витлумачити як добровільну благодійну
            допомогу (наприклад, купівля інструментів і ліків в лікарнях, внески
            у фонд школи чи класу), вважалося, що респондент мав досвід корупції
            лише якщо його змушували це робити.
          </p>
          <p>
            Регіональні показники показувалися, якщо показник показувався від
            сукупності не менше 20 респондентів.
          </p>
          <p>
            Вважалося, що респондент готовий долучитися до антикорупційної
            боротьби, якщо він заявляв про готовність долучитися до хоча б
            однієї з запропонованих активностей:
          </p>
          <ul>
            <li>
              Брати участь у громадських радах або громадських слуханнях для
              нагляду за державними установами та їхніми рішеннями
            </li>
            <li>
              Ініціювати та підписувати петиції до місцевих, обласних та
              національних органів влади
            </li>
            <li>
              Повідомляти про корупцію засобам масової інформації, в тому числі
              в соціальних мережах, для привернення уваги і тиску
            </li>
            <li>
              Звертатися до народних депутатів для привернення уваги і тиску
            </li>
            <li>
              Повідомляти про випадки корупції правоохоронним органам (НАБУ,
              поліція) та НАЗК
            </li>
            <li>
              Подавати скарги на випадки корупції до державних органів, у яких
              вона спостерігалася
            </li>
            <li>Брати участь у мітингах та публічних протестах</li>
            <li>
              Підтримувати антикорупційні громадські організації та ініціативи
              та брати участь в їх діяльності
            </li>
          </ul>
          <p>
            Питання відносно динаміки сприйняття корупції секції "Корупція на тлі інших проблем" відрізнялися впродовж років.
          </p>
          <ul>
            <li>
              Для 2007, 2009 та 2011 років: "Як Ви вважаєте, наскільки серйозними є нижче перераховані проблеми для України: Корупція в уряді".
            </li>
            <li>
              Для 2015 року: "Як Ви вважаєте, наскільки серйозними є нижче перераховані проблеми для України: Корупція в цілому".
            </li>
            <li>
              Для 2018, 2021, 2023 та 2024 років: "Як Ви вважаєте, наскільки серйозними є нижче перераховані проблеми для України: Корупція".
            </li>
          </ul>
          <p>
            Дані для слайдеру секції "Корупція на тлі інших проблем" відображають відповіді "Так" на питання 
            "Чи доводилось Вам або членам Вашої родини за останні 12 місяців стикатися з будь-якими проявами 
            корупції з боку представників державних органів, в тому числі освітніх, медичних чи інших організацій 
            (від Вас вимагали (відкрито чи ні) чи Ви самі пропонували неофіційну оплату у формі грошей, подарунків, протекції, послуг)?". 
            Однак, впродовж років це питання змінювалося.
          </p>
          <ul>
            <li>
              Для2007, 2009 та 2011років: "Чи були ви або ваша родина за останні 12 місяців залучені до будь-якої форми корупції з будь-якими державними службовцями, 
              включаючи освітні, медичні чи інші організації?". Відповідь "Так" використана.
            </li>
            <li>
              Для 2015 рокупитання замінено іншим: "Як часто ви стикаєтеся з будь-якою формою корупції?". Сума варіантів відповідей "Щодня", "Щотижня", 
              "Щомісяця", "Кілька разів на рік" та "Щороку" використана.
            </li>
            <li>
              Для 2018 року: "Чи стикалися безпосередньо Ви або члени Вашої сім’ї з корупцією за останні 12 місяців – тобто Ви давали або від Вас вимагали хабаря, використовували зв’язки тощо?". 
              Сума варіантів відповідей "Так, я особисто стикався (-лася)" та "Я не стикався (-лася), але члени моєї сім’ї стикалися" використана.
            </li>
          </ul>
        </div>
      </footer>
    <div id="social">
      <a href="https://www.facebook.com/sharer/sharer.php?u=http://texty.org.ua/d/2024/pact/"
        class="share-btn">
        <img :src="fbLogo">
      </a>
      <!-- <a href="https://twitter.com/intent/tweet?text=http://texty.org.ua/d/2019/pact/" class="share-btn">
        <img :src="twitterLogo">
      </a> -->
    </div>
    <div id="donors">
      <p>
        Цю інтерактивну інфографіку підготовлено в рамках Програми сприяння
        громадській активності «Долучайся!», що фінансується Агентством США з
        міжнародного розвитку (USAID) та здійснюється Pact в Україні. Зміст
        інфографіки є винятковою відповідальністю Pact та його партнерів i не
        обов’язково відображає погляди Агентства США з міжнародного розвитку
        (USAID) або уряду США.
      </p>
      <p>
        Дані для інфографіки взяті з опитувань, проведених за підтримки
        Агентства США з міжнародного розвитку (USAID) в 2007 – 2009 роках MSI,
        а з 2011 – організацією Pact.
      </p>
    </div>
  </main>
</template>

<script>
import increaseFont from './static/images/increase-font-size.png'
import changeBackground from './static/images/change-background.png'
import twitterLogo from './static/images/twitter-logo.png'
import fbLogo from './static/images/fb-logo.png'
import close from './static/images/close.png'
import pact from './static/images/pact.png'
import engageLabel from './static/images/engage-label.png'
import usaid from './static/images/usaid.png'
import arrowLeft from './static/images/arrow-left.png'
import arrowRight from './static/images/arrow-right.png'
import MapBase from './components/MapBase.vue'
import LineChartBase from './components/LineChartBase.vue'
import RadarChartBase from './components/RadarChartBase.vue'
import section_1_1 from './data/section_1_1.json'
import section_1_2 from './data/section_1_2.json'
import section_1_3 from './data/section_1_3.json'
import section_2_1 from './data/section_2_1.json'
import section_2_2 from './data/section_2_2.json'
import section_3 from './data/section_3.json'
import section_4_1 from './data/section_4_1.json'
import section_4_2 from './data/section_4_2.json'
import section_5_1 from './data/section_5_1.json'
import section_5_2 from './data/section_5_2.json'
import Toggle from '@vueform/toggle'

export default {
  name: 'App',
  components: {
    MapBase,
    LineChartBase,
    RadarChartBase,
    Toggle
  },
  data() {
    return {
      darkTheme: false,
      fontSizeLarge: false,
      increaseFont,
      changeBackground,
      close,
      pact,
      twitterLogo,
      fbLogo,
      usaid,
      engageLabel,
      arrowLeft,
      arrowRight,
      section_1_1,
      section_1_2,
      section_1_3,
      section_2_1,
      section_2_2,
      section_3,
      section_4_1,
      section_4_2,
      section_5_1,
      section_5_2,
      sectionRegionSelected: 0,
      sectionColors_1: ['rgb(124, 0, 85)', 'rgb(0, 118, 163)', 'rgb(106, 138, 34)', 'rgb(211, 168, 9)', 'rgb(114, 105, 99)'],
      sectionColors_2_1: ['rgb(136, 172, 46)', 'rgb(0, 146, 200)', 'rgb(255, 203, 5)'],
      sectionColors_2_2: ['rgb(154, 0, 100)', 'rgb(202, 108, 24)', 'rgb(90, 42, 0)'],
      sectionColors_3: ['rgb(0, 118, 163)', 'rgb(124, 0, 85)', 'rgb(106, 138, 34)'],
      sectionSwitch_1: false,
      sectionCategories_3:[ 
        'Стать',
        'Вік',
        'Освіта',
        'Дохід',
        'Місцевість'
      ],
      sectionCategory_3: 'Освіта',
      sectionCategories_4:[ 
        'кабінет міністрів україни та його міністерства',
        'верховна рада україни',
        'прокуратура',
        'служба безпеки україни',
        'судова система',
        'національна поліція',
        'національне антикорупційне бюро',
        'національне агентство з питань запобігання корупції',
        'спеціалізована антикорупційна прокуратура',
        'обласні органи влади',
        'місцеві (міські, сільські, селищні) органи влади',
        'бізнес спільнота',
        'громадські організації',
        'засоби масової інформації',
        'прості громадяни',
        'президент та його офіс'
      ],
      sectionCategory_4: 'кабінет міністрів україни та його міністерства',
      sectionSwitch_4: false,
      sectionCategories_5: [ 
      'отримання медичних послуг',
      'керівництво шкіл та вчителі',
      'допомога з безробіття, субсидії, інші соцвиплати',
      'підключення чи ремонт комунальних послуг або зв‘язку',
      'керівництво вищих навчальних закладів та їх викладачі',
      'національна поліція',
      "реєстрація або приватизація об‘єктів нерухомості",
      'приватизація, володіння та користування землею',
      'митний контроль чи оформлення митних документів',
      'державні нотаріуси',
      'отримання різних дозволів в органах влади',
      'судова система',
      'податкові служби',
      'регламентація та перевірки підприємств',
      'органи призову на військову службу',
      'влаштування на роботу до державної установи',
      'отримання кредиту (позики) в державній установі',
      'отримання державного житла',
      'прокуратура',
      'система державних закупівель'
      ],
      sectionCategory_5: 'отримання медичних послуг',
      sectionSwitch_5: false,
      methodologyVisible: false,
      switcherHover_1: false,
      switcherHover_4: false,
      switcherHover_5: false,
    }
  },
  computed: {
    sectionData_1_1() {
      return this.sectionSwitch_1 ? this.section_1_1[1] : this.section_1_1[0]
    },
    sectionData_1_2() {
      return this.sectionSwitch_1 ? this.section_1_2[1] : this.section_1_2[0]
    },
    sectionData_1_3() {
      return this.sectionSwitch_1 ? this.section_1_3[1][27] : this.section_1_3[0][27]
    },
    sectionData_1_4() {
      return this.sectionSwitch_1 ? this.section_1_3[1][this.sectionRegionSelected] : this.section_1_3[0][this.sectionRegionSelected]
    },
    sectionCategoryLeft_3() {
      return this.sectionCategories_3[(this.sectionCategories_3.indexOf(this.sectionCategory_3) - 1 + this.sectionCategories_3.length) % this.sectionCategories_3.length]
    },
    sectionCategoryRight_3() {
      return this.sectionCategories_3[(this.sectionCategories_3.indexOf(this.sectionCategory_3) + 1) % this.sectionCategories_3.length]
    },
    sectionDataChart_3() {
      return this.section_3.filter(item => item.name === this.sectionCategory_3)[0].regions[27]
    },
    sectionCategoryLeft_4() {
      return this.sectionCategories_4[(this.sectionCategories_4.indexOf(this.sectionCategory_4) - 1 + this.sectionCategories_4.length) % this.sectionCategories_4.length]
    },
    sectionCategoryRight_4() {
      return this.sectionCategories_4[(this.sectionCategories_4.indexOf(this.sectionCategory_4) + 1) % this.sectionCategories_4.length]
    },
    sectionDataChart_4() {
      return this.sectionSwitch_4 ? this.section_4_2.filter(item => item.name === this.sectionCategory_4)[0].regions[27] : this.section_4_1.filter(item => item.name === this.sectionCategory_4)[0].regions[27]
    },
    sectionCategoryLeft_5() {
      return this.sectionCategories_5[(this.sectionCategories_5.indexOf(this.sectionCategory_5) - 1 + this.sectionCategories_5.length) % this.sectionCategories_5.length]
    },
    sectionCategoryRight_5() {
      return this.sectionCategories_5[(this.sectionCategories_5.indexOf(this.sectionCategory_5) + 1) % this.sectionCategories_5.length]
    },
    sectionDataChart_5() {
      return this.sectionSwitch_5 ? this.section_5_2.filter(item => item.name === this.sectionCategory_5)[0].regions[27] : this.section_5_1.filter(item => item.name === this.sectionCategory_5)[0].regions[27]
    },
    sectionColor_1() {
      return this.sectionSwitch_1 ? '0, 118, 163' : '124, 0, 85'
    }
  },
  methods: {
    changeTheme() {
      this.darkTheme = !this.darkTheme
      this.darkTheme ? document.body.classList.add('dark') : document.body.classList.remove('dark')
    },
    changeFontSize() {
      this.fontSizeLarge = !this.fontSizeLarge
      this.fontSizeLarge ? document.body.classList.add('large-font') : document.body.classList.remove('large-font')
    },
    cancelInclusiveMode() {
      this.darkTheme = false
      this.fontSizeLarge = false
      document.body.classList.remove('dark')
      document.body.classList.remove('large-font')
    },
    regionSelected(region) {
      const emptyRegions = [5, 8, 11, 20, 25, 26, 27, 17]
      if (!emptyRegions.includes(region)) {
        this.sectionRegionSelected = region
      }
    },
    sectionPrev_3() {
      this.sectionCategory_3 = this.sectionCategoryLeft_3
    },
    sectionNext_3() {
      this.sectionCategory_3 = this.sectionCategoryRight_3
    },
    sectionPrev_4() {
      this.sectionCategory_4 = this.sectionCategoryLeft_4
    },
    sectionNext_4() {
      this.sectionCategory_4 = this.sectionCategoryRight_4
    },
    sectionPrev_5() {
      this.sectionCategory_5 = this.sectionCategoryLeft_5
    },
    sectionNext_5() {
      this.sectionCategory_5 = this.sectionCategoryRight_5
    },
    mapColor(index) {
      return this.sectionColors_3[index].replace('rgb(', '').replace(')', '')
    },
    sectionMapCategoryFilter_3(question) {
      let data = this.section_3.filter(item => item.name === this.sectionCategory_3)[0].regions
      data = data.map(item => {
        return {
          name: item.name,
          code: item.code,
          id: item.id,
          d: item.d,
          amount: item.questions.filter(q => q.name === question)[0].amount,
          totalAmount: item.questions.filter(q => q.name === question)[0].totalAmount,
          percentage: item.questions.filter(q => q.name === question)[0].percentage
        }
      })
      return data;
    },
    sectionMapCategoryFilter_4(question) {
      let data;
      if (!this.sectionSwitch_4) {
        data = this.section_4_1.filter(item => item.name === this.sectionCategory_4)[0].regions
      } else {
        data = this.section_4_2.filter(item => item.name === this.sectionCategory_4)[0].regions
      }
      data = data.map(item => {
        return {
          name: item.name,
          code: item.code,
          id: item.id,
          d: item.d,
          years: item.questions.filter(q => q.name === question)[0].years,
          amount: item.questions.filter(q => q.name === question)[0].amount,
          totalAmount: item.questions.filter(q => q.name === question)[0].totalAmount,
          percentage: item.questions.filter(q => q.name === question)[0].percentage
        }
      })
      return data;
    },
    sectionMapCategoryFilter_5(question) {
      let data;
      if (!this.sectionSwitch_5) {
        data = this.section_5_1.filter(item => item.name === this.sectionCategory_5)[0].regions
      } else {
        data = this.section_5_2.filter(item => item.name === this.sectionCategory_5)[0].regions
      }
      data = data.map(item => {
        return {
          name: item.name,
          code: item.code,
          id: item.id,
          d: item.d,
          years: item.questions.filter(q => q.name === question)[0].years,
          amount: item.questions.filter(q => q.name === question)[0].amount,
          totalAmount: item.questions.filter(q => q.name === question)[0].totalAmount,
          percentage: item.questions.filter(q => q.name === question)[0].percentage
        }
      })
      return data;
    }
  }
}
</script>

<style src="@vueform/toggle/themes/default.css"></style>
<style lang="sass">
@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap')

body
  color: rgb(44, 62, 80)

body.dark
  background-color: #000
  color: #fff

body.large-font
  font-size: 20px

main
  max-width: 1000px
  margin: auto
  font-family: 'Roboto', sans-serif

.visually-impaired
  padding: 0 5px
  display: flex
  background-color: #d3d3d3
  justify-content: flex-end
  align-items: center
  margin-bottom: 5px

.visually-impaired-icon
  width: 30px
  height: 30px
  margin: 0 10px
  cursor: pointer
  transition: all 0.3s ease-in-out
  &:hover
    transform: scale(1.1)

.title
  display: flex
  justify-content: space-between
  align-items: center
  margin: 20px 0
  & img
    height: 90px

h1
  color: #7c0055
  font-size: 36pt

.section-title-block
  display: flex
  flex-direction: column
  height: 100px
  align-items: center
  & p 
    margin: 0

.section-title
  font-weight: 700
  background-color: rgba(140,50,85,.2)
  padding: 5px
  margin: 40px 0 10px

.block-subtitle
  text-align: center
  font-size: 18px
  font-weight: 100
  letter-spacing: 3px
  text-transform: uppercase

.questions-block
  display: flex
  flex-direction: column
  align-items: flex-start

.block-subtitle.section_1
  margin: 0

.section-columns
  display: flex
  justify-content: space-between
  align-items: center
  gap: 20px

.section-columns.map
  align-items: flex-start
  margin-top: 20px

.section-columns-around
  display: flex
  justify-content: space-around
  align-items: center

.section-column
  display: flex
  flex-direction: column
  align-items: center    

.section-column-start
  display: flex
  flex-direction: column
  align-items: start   

.color-dot
  border-radius: 50%
  width: 12px
  height: 12px
  margin-right: 15px
  float: left
  flex-shrink: 0

.question-title
  display: flex
  align-items: center
  margin-bottom: 10px
  justify-content: center
  max-width: 80%

.switcher
  z-index: 100
  position: relative
  display: flex
  align-items: flex-end
  flex-direction: column
  width: 100%
  margin-left: auto
  & p 
    margin: 5px 0 0 0
  & div 
    float: right

.switcher-tooltip
  position: absolute
  padding: 10px
  bottom: 0
  width: 150px
  height: max-content
  background-color: rgb(239, 239, 239)
  opacity: 1
  transform: translateY(100%)
  transition: all 0.3s ease-in-out
  &.hidden
    opacity: 0
    pointer-events: none
    

.section-selector
  display: flex
  justify-content: space-around
  gap: 20px

.section-selector
  display: flex
  align-items: center
  gap: 20px
  & img
    width: 50px
    height: 50px
    cursor: pointer

.selector-block
  display: flex
  align-items: center
  min-width: 300px

.selector-block.center
  width: 400px
  justify-content: center
  flex-direction: column

.selector-block.left
  justify-content: right

.selector-block.right
  justify-content: left

.block-subtitle-selector
  font-size: 18px
  font-weight: 100
  letter-spacing: 3px
  text-transform: uppercase
  margin: 0 20px
  opacity: 0.5

.section-question-block
  display: flex
  gap: 10px
  justify-content: space-between
  & div
    display: flex
    gap: 5px
    align-items: center

.section-question:not(:last-child)
  padding: 0 20px
  border-right: 2px solid #d3d3d3

.section-question
  flex: 1 0 30%
  min-height: 80px

.selector-block
  flex: 1 0 33%

.subtitle
  font-size: 13px
  font-style: italic
  margin-top: 40px

.methodology-button
  display: block
  cursor: pointer
  margin: 10px auto
  text-transform: uppercase
  background-color: #7c0055
  border: none
  color: #fff
  padding: 15px 32px
  text-align: center
  text-decoration: none
  font-size: 16px

footer
  // text-align: center
  margin-top: 50px

#social
  display: flex
  justify-content: center
  margin: 60px auto

.share-btn
  & img
    margin: 0 10px
    width: 40px
    height: 40px
    cursor: pointer
    transition: all 0.3s ease-in-out
    &:hover
      transform: scale(1.1)

#donors
  font-size: 14px

footer div table td, footer div table th
  border-spacing: 0
  margin: 0
  padding: 5px
  border: 1px solid grey

footer div table
  border-collapse: collapse

.section-column-radar
  min-width: 300px
  text-align: center

.people-number
  text-align: end

.innerPageLink 
  font-weight: 700
  color: inherit
  border-bottom: 1px dashed #7c0055
  text-decoration: none

</style>
